import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const rocheLeadTextCss = ":host{display:block;margin-top:3rem;margin-top:0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .lead-text{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:1.25rem;line-height:2rem;margin-top:2rem}@media (min-width: 48rem){:host .lead-text{font-size:1.375rem;line-height:2.1875rem}}@media (min-width: 90rem){:host .lead-text{font-size:1.625rem;line-height:2.625rem}}@media (min-width: 90rem){:host .lead-text{margin-top:2.5rem}}";
const RocheLeadTextStyle0 = rocheLeadTextCss;

const RocheLeadText$1 = /*@__PURE__*/ proxyCustomElement(class RocheLeadText extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h("p", { key: 'c5dd9e56b4a7104714b56fe329cfa8254bd9cfa4', class: "lead-text" }, h("slot", { key: '4b261db46bda304f6e460a92722494d94624b512' })));
    }
    static get style() { return RocheLeadTextStyle0; }
}, [1, "roche-lead-text"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-lead-text"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-lead-text":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheLeadText$1);
            }
            break;
    } });
}

const RocheLeadText = RocheLeadText$1;
const defineCustomElement = defineCustomElement$1;

export { RocheLeadText, defineCustomElement };

//# sourceMappingURL=roche-lead-text.js.map